import { SvgProps } from "./Form";

export const TrashSimple = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    {...props}
  >
    <path
      d="M11.8334 2.33333H8.91675V1.16667C8.91675 0.857247 8.79383 0.560501 8.57504 0.341709C8.35625 0.122916 8.0595 0 7.75008 0L4.25008 0C3.94066 0 3.64392 0.122916 3.42512 0.341709C3.20633 0.560501 3.08341 0.857247 3.08341 1.16667V2.33333H0.166748V3.5H1.33341V12.25C1.33341 12.7141 1.51779 13.1592 1.84598 13.4874C2.17417 13.8156 2.61929 14 3.08341 14H8.91675C9.38088 14 9.826 13.8156 10.1542 13.4874C10.4824 13.1592 10.6667 12.7141 10.6667 12.25V3.5H11.8334V2.33333ZM4.25008 1.16667H7.75008V2.33333H4.25008V1.16667ZM9.50008 12.25C9.50008 12.4047 9.43862 12.5531 9.32923 12.6625C9.21983 12.7719 9.07146 12.8333 8.91675 12.8333H3.08341C2.9287 12.8333 2.78033 12.7719 2.67094 12.6625C2.56154 12.5531 2.50008 12.4047 2.50008 12.25V3.5H9.50008V12.25Z"
      fill="currentColor"
    />
    <path
      d="M5.41666 5.83298H4.25V10.4996H5.41666V5.83298Z"
      fill="currentColor"
    />
    <path
      d="M7.75017 5.83298H6.5835V10.4996H7.75017V5.83298Z"
      fill="currentColor"
    />
  </svg>
);
